import React from 'react'
import App from './App'
import TBCEditor from './component_tbc_editor/TBCEditor'

import FacebookLogin from 'react-facebook-login';

import HeaderMenu from './component_tbc_editor/menu/HeaderMenu'
import Main from './component_tbc_editor/main/Main'

import ModalStory from './component_tbc_editor/modal/ModalStory'
import ModalStoryEpisode from './component_tbc_editor/modal/ModalStoryEpisode'
import ModalLogin from './component_tbc_editor/modal/ModalLogin'
import ModalProfile from './component_tbc_editor/modal/ModalProfile'
import ModalMemberProfile from './component_tbc_editor/modal/ModalMemberProfile'
import AppZipCreator from './AppZipCreator'

import GlobalStorage from './component_tbc_editor/storage/GlobalStorage'
import AppConnector from './AppConnector'
import { Container, Button, Modal, ModalHeader, ModalBody, ModalFooter,InputGroup, Input,InputGroupAddon, Label } from 'reactstrap';
import axios from 'axios'
import qs from 'qs'
import { SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION } from 'constants';
import Cookies from 'js-cookie'


export default class AppEditor extends React.Component
{

  constructor(props)
  {
    super(props);
    this.state = {
      openModal: false,
      modal:'',
      modalStep:1
    }
    this.toggleModal = this.toggleModal.bind(this);    
    this.toggleModalState = this.toggleModalState.bind(this);    
    this.switchMain = this.switchMain.bind(this);
    this.switchMenu = this.switchMenu.bind(this);
    this.GS = new GlobalStorage();
    console.log("//Cookies.get('reader')");
    console.log(Cookies.get('reader'));
    if (Cookies.get('reader')!==undefined){
      this.GS.setUser(JSON.parse(Cookies.get('reader')));      
      let connector = new AppConnector();
      connector.listStory(()=>{},1);

    }
  }  

  toggleModalState(current_modal,step) 
  {
    var step = step || 1;
    this.setState(prevState => ({      
      modal:current_modal,
      modalStep:step
    }));
    
  }
  toggleModal(open) 
  {
    var open = open || false;    
    
    if (!open)
      this.setState(prevState => ({
        openModal: !prevState.openModal,      
      }));
    else
    this.setState(prevState => ({
      openModal: open
    }));
    
  }

  switchMain(state)
  {
    this.Main.switchMain(state);
  }
  switchMenu(state)
  {
    this.HeaderMenu.switchMenu(state);
  }

  render()
  {
    return (
             
        <div>
          <div id="demo" class="text-white">

          </div>

          {/*
          <TBCEditor
              onPlay={(episode) => this.App.forcePlay(episode)}
          />
          */}

          <HeaderMenu ref={(v)=> {this.HeaderMenu = v;}} toggleModalState={this.toggleModalState} toggleModal={this.toggleModal} switchMain={this.switchMain} switchMenu={this.switchMenu}></HeaderMenu>
          
          <Main ref={(v)=> {this.Main = v;}} toggleModalState={this.toggleModalState} toggleModal={this.toggleModal} switchMain={this.switchMain} switchMenu={this.switchMenu}></Main>

          {(global.DEBUG)?(
          <Container className={"fixed-bottom"}>
            <Button onClick={()=>{this.switchMenu("Home");this.switchMain("Home")}}>Home</Button>
            <Button onClick={()=>{this.switchMenu("StoryList");this.switchMain("StoryList")}}>StoryList</Button>
            <Button onClick={()=>{this.switchMenu("Story");this.switchMain("Story")}}>Story</Button>
            <Button onClick={()=>{this.switchMenu("StoryEpisode");this.Main.switchMain("StoryEpisode")}}>StoryEpisode</Button>
            <Button onClick={()=>{this.switchMenu("StoryEpisodeHTML");this.Main.switchMain("StoryEpisodeHTML")}}>HTMLEpisode</Button>

            <Button onClick={()=>{this.toggleModal(true);this.toggleModalState('login')}}>login</Button>
            <Button onClick={()=>{this.toggleModal(true);this.toggleModalState('createStory')}}>createStory</Button>
            <Button onClick={()=>{this.toggleModal(true);this.toggleModalState('createEpisode')}}>createEpisode</Button>

            
            <Button onClick={()=>{this.toggleModal(true);this.toggleModalState('preview');}}>Preview</Button>
            <Button onClick={()=>{this.toggleModal(true);this.toggleModalState('updateProfile');}}>updateProfile</Button>
            <Button onClick={()=>{this.toggleModal(true);this.toggleModalState('updateMemberProfile');}}>updateMemberProfile</Button>
            

            <Button onClick={()=>{console.log(this.GS.getStoryEpisode())
            document.getElementById("demo").innerHTML = JSON.stringify((this.GS.getStoryEpisode()));
            }}>getStoryEpisode</Button>

            <Button onClick={()=>{console.log(this.GS.getStory())            
            }}>getStory</Button>

            <Button onClick={()=>{console.log(this.GS.getUser())            
            }}>getUser</Button>
            <Button onClick={()=>{
              console.log(this.GS.getHtml());
            }}>getHtml</Button>

            <Button onClick={()=>{
              let connector = new AppConnector();
              connector.listStoryDetail({},this.GS.getStory().uuid);
            }}>listStoryDetail</Button>

            
          </Container>
          ):null}
          <style dangerouslySetInnerHTML={{__html: `

          .fa.disabled,
          .fa[disabled],
          .disabled > .fa,
          [disabled] > .fa {
            color: lightgrey;
            /*or*/ opacity: 0.5;
          }

          .MenuButton{
            cursor:pointer;
          }
          .item{
            margin:5px 0;
          }
          .storycard {            
            padding: 0.5rem 1rem;
            marginBottom: .5rem;
            backgroundColor: white;
            cursor: pointer;
            color:#FFF;
          }

          .storycard.selected {
            background:rgba(255,255,255,0.2);
          }
          @keyframes border-dance {
            from {
              background-position: 0% bottom;
            }
            to {
              background-position: 100% bottom;
            }
          }
          #card-0{display:none}
          
          html, body, div#root {
            width: 100%;
            height: 100%;
            font-family: Microsoft JhengHei,helvetica, sans-serif;
            background-color:#000;
          }
          .modal.show .modal-dialog.preview{
            margin-top:0;
          }

          .navbar-dark .navbar-brand{
            font-family: 'American Typewriter';
          }

          [contenteditable]:after {
              width: 8px;
              height: 8px;
          
              // place the icon on the same line with text
              display: inline-block;
          
              // creates new element
              content: ''
          }

          [contenteditable]:after {
            content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAiUlEQVQ4y2NgGFKgs7OTl2zNEyZMmAgEDZMmTeogWTNQUwVQcyeIDaLnz5/PQYrmssmTJ1sC6QQg7gXiFlI0l4I0Q9lOQNuLiNYMVFwCxFZQtiPQgEKSNAM1WMM0k2wzTDPQ+Q5AdjEpfs6CRRPJmqEGvAC6IAlId4NcQk58vwDih0DbMxhGDgAAx6ZVXMd4yEMAAAAASUVORK5CYII=")
          }
        
          #ball-1{
            -webkit-animation-name: bounce;
            -webkit-animation-delay: 1s;
            -webkit-animation-duration: 1.2s;
            -webkit-animation-iteration-count: infinite;
          }
          #ball-2{
            -webkit-animation-name: bounce;
            -webkit-animation-delay: 1.1s;
            -webkit-animation-duration: 1.2s;
            -webkit-animation-iteration-count: infinite;
          }
          #ball-3{
            -webkit-animation-name: bounce;
            -webkit-animation-delay: 1.2s;
            -webkit-animation-duration: 1.2s;
            -webkit-animation-iteration-count: infinite;
          }
          
          @-webkit-keyframes bounce {
            0% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(23px);
            }
            60% {
              transform: translateY(-25px);
            }
            80%{
              transform: translateY(0);
            }
          }
          .circle {
            display: inline-block;
            background-color: white;
            height: 25px;
            width: 25px;
            border-radius: 25px;
            margin:0 15px;

          }

        .hovereffect {
            width: 100%;
            height: 100%;
            float: left;
            overflow: hidden;
            position: relative;            
            cursor: default;
        }
        .hovereffect .overlay {
          height: 100%;
          width: 100%;
          position: absolute;
          overflow: hidden;
          left: 0;
          top: 0;
          bottom: auto;
          padding: 1em;          
          background: #79FAC4;
          color: #3c4a50;
          visibility: hidden;          
        }
        .hovereffect:hover .overlay{
          background-color: rgba(100,100,100,0.4);          
        }
        .hovereffect:hover .overlay , .hovereffect:hover p.icon-links h2, .hovereffect:hover p.icon-links a{
          visibility: visible;
        }

        
        .hovereffect img {
            display: block;
            position: relative;
          -webkit-transition: -webkit-transform 0.35s;
          transition: transform 0.35s;
        }
        
        .hovereffect:hover img {
          /*-webkit-transform: translate3d(0,-10%,0);
          transform: translate3d(0,-10%,0);*/
        }
        
        .hovereffect h2 {
            text-transform: uppercase;
            color: #fff;
            text-align: center;
            position: relative;
            font-size: 17px;
            padding: 10px;
            background: rgba(0, 0, 0, 0.6);
            float: left;
            margin: 0px;
            display: inline-block;
        }
                
        
        
        .hovereffect p.icon-links a {
          float: right;
          color: #3c4a50;
          font-size: 1.4em;
        }
        
        .hovereffect:hover p.icon-links a:hover,
        .hovereffect:hover p.icon-links a:focus {
          color: #252d31;
        }
        
        .hovereffect h2,
        .hovereffect p.icon-links a {
          -webkit-transition: -webkit-transform 0.35s;
          transition: transform 0.35s;
          -webkit-transform: translate3d(200%,0,0);
          transform: translate3d(200%,0,0);
          visibility: hidden;
        }
        
        .hovereffect p.icon-links a span:before {
          display: inline-block;
          padding: 8px 10px;
          speak: none;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        
        
        .hovereffect:hover .overlay,
        .hovereffect:hover h2,
        .hovereffect:hover p.icon-links a {
          -webkit-transform: translate3d(0,0,0);
          transform: translate3d(0,0,0);
        }
        
        .hovereffect:hover h2 {
          -webkit-transition-delay: 0.05s;
          transition-delay: 0.05s;
        }
        
        .hovereffect:hover p.icon-links a:nth-child(3) {
          -webkit-transition-delay: 0.1s;
          transition-delay: 0.1s;
        }
        
        .hovereffect:hover p.icon-links a:nth-child(2) {
          -webkit-transition-delay: 0.15s;
          transition-delay: 0.15s;
        }
        
        .hovereffect:hover p.icon-links a:first-child {
          -webkit-transition-delay: 0.2s;
          transition-delay: 0.2s;
        }

        .inputfile {
          width: 0.1px;
          height: 0.1px;
          opacity: 0;
          overflow: hidden;
          position: absolute;
          z-index: -1;
        }
        
      
      .inputfile + label {
        cursor: pointer; /* "hand" cursor */
      }
      .inputfile:focus + label {
        outline: 1px dotted #000;
        outline: -webkit-focus-ring-color auto 5px;
      }

      .tab-pane.active {
        animation: slide-down 0.2s ease-out;
    }
    .hoverBtn{
      cursor:pointer
    }

    .close.closeTab{
      line-height:0.8;
    }

    .custom-file-input ~ .custom-file-label::after {
      content: "瀏覽" !important;
  }

  .pagination{
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: end;
    justify-content: flex-end;
    margin: 50px auto;  
}

  .pagination li{
    cursor:pointer;
    background: #fff;
    border: 1px solid #ddd;
    color: #0cc2aa;
    float: left;
    height: 40px;
    line-height: 40px;
    margin-left: -1px;
    position: relative;
    width: 40px;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
  }
  .pagination li.active{
  background-color: #0cc2aa;
    border-color: #0cc2aa;
    color: #fff;
    cursor: default;
    font-weight: 500;
    outline: none;
    z-index: 2;
  }
          
  .bg-dark{
    background-color:#000 !important;
  }
          `}}>
          </style>

          <Modal isOpen={this.state.openModal} className={this.state.modal}>
            {
              this.state.modal=='login'?(
                <ModalLogin 
                    toggleModal={this.toggleModal} 
                    toggleModalState={this.toggleModalState} 
                    switchMain={this.switchMain} 
                    switchMenu={this.switchMenu}
                    modalStep={this.state.modalStep}
                ></ModalLogin>
              ):null
            }
            {
              this.state.modal=='createStory'?(
                <ModalStory 
                  toggleModal={this.toggleModal} 
                  toggleModalState={this.toggleModalState} 
                  switchMain={this.switchMain} 
                  switchMenu={this.switchMenu}
                  modalStep={this.state.modalStep}
                ></ModalStory>
              ):null
            }                        
            {
              this.state.modal=='createEpisode'?(
                <ModalStoryEpisode 
                  toggleModal={this.toggleModal} 
                  toggleModalState={this.toggleModalState} 
                  switchMain={this.switchMain} 
                  switchMenu={this.switchMenu}
                  modalStep={this.state.modalStep}
                ></ModalStoryEpisode>
              ):null
            }   
            {
              this.state.modal=='updateProfile'?(
                <ModalProfile 
                  toggleModal={this.toggleModal} 
                  toggleModalState={this.toggleModalState} 
                  switchMain={this.switchMain} 
                  switchMenu={this.switchMenu}
                  modalStep={this.state.modalStep}
                ></ModalProfile>
              ):null
            }
            {
              this.state.modal=='updateMemberProfile'?(
                <ModalMemberProfile 
                  toggleModal={this.toggleModal} 
                  toggleModalState={this.toggleModalState} 
                  switchMain={this.switchMain} 
                  switchMenu={this.switchMenu}
                  modalStep={this.state.modalStep}
                ></ModalMemberProfile>
              ):null
            }     
            {
              //always render App for this.App reference
            }
            <div style={{display:(this.state.modal=='preview')?`show`:`none`}}>
              <ModalHeader toggle={()=>{this.toggleModal()}}>故事預覽              
              </ModalHeader>
              <ModalBody style={{height: '770px'}}>
                <App ref={(v) => {this.App = v;}}></App>
              </ModalBody>
              
              <ModalFooter>              

              <Button color="primary" onClick={()=>{
                  this.App.forcePlay(this.GS.parseStoryEpisodeItemsToJsonObject());
              }}>重載</Button>
              <Button color="primary" onClick={()=>{
                  this.App.TBCEpisodeViewer.prevScene();
              }}>上一頁</Button>
              <Button color="primary" onClick={()=>{
                  this.App.TBCEpisodeViewer.nextScene();
                }}>下一頁</Button>
              </ModalFooter>
            </div>
              
                               
          </Modal>
          
          <FacebookLogin
                    appId={global.facebook_app_id}
                    autoLoad={true}
                    scope="public_profile,email"            
                    callback={(response)=>{
                      console.log(response.accessToken);
                      this.facebook_login(response.accessToken);
                    }} 
                    version="5.0"
                    xfbml={true}
                    cookie={true}
                    size="btn-primary"
                    cssClass="d-none"
                    autoLoad="true"
                    fields="id,name"
                    />
        </div>
      
    )
  }
}